import { useQuery } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";
import { taskpartStudentTiers } from "@/data/taskpartProduct";

export function usePricing() {
  return useQuery({
    queryKey: ["pricing"],
    queryFn: async () => {
      const res = await apiClient.get("/settings/pricing");
      const data = res.data.data;
      
      // Update the local data with dynamic pricing
      const updated = taskpartStudentTiers.map((tier) => {
        if (tier.id === "verified") {
          return {
            ...tier,
            priceLabel: data.verified_label || tier.priceLabel,
          };
        }
        if (tier.id === "premium") {
          return {
            ...tier,
            priceLabel: data.premium_label || tier.priceLabel,
          };
        }
        return tier;
      });

      return {
        verifiedPrice: data.verified_price || "10000",
        premiumPrice: data.premium_price || "50000",
        verifiedLabel: data.verified_label || "TZS 10,000 / year",
        premiumLabel: data.premium_label || "TZS 50,000 one-time",
        tiers: updated,
      };
    },
  });
}

export function useAdminSettings() {
  return useQuery({
    queryKey: ["admin-settings"],
    queryFn: async () => {
      const res = await apiClient.get("/admin/settings");
      return res.data.data;
    },
  });
}

export function useUpdateAdminSettings() {
  return useQuery({
    queryKey: ["update-admin-settings"],
    queryFn: async () => {
      // This is handled via mutation in the component
      return null;
    },
  });
}
